// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__pO8c-","info":"UpdateTermsInfo_info__2iq26"};